import { WalletStatus } from '../../enum/mysec/wallet-status.enum';
import { WalletModel } from './wallet.model';

export class Wallet {
  balance: number;
  pendingAmount: number;
  // #119: the buckets that make up `pendingAmount` (Balance on Hold).
  // Default to 0 so a missing field still renders a zero subtotal (and is not drillable).
  openOrdersHoldAmount: number;
  withdrawalRequestsHoldAmount: number;
  // ECF investment bucket — Paid pledges held on pre-allotment campaigns.
  ecfInvestmentHoldAmount: number;
  status: WalletStatus;
  ecfAccountNo: string;
  userId: string;

  // FRC-858: the amount the user can actually withdraw (Balance - Balance on Hold).
  // Clamped at 0 so a hold that exceeds the balance — or a balance/hold field the API
  // omitted — can never surface a negative or NaN figure in the withdraw popup.
  get withdrawableBalance(): number {
    return Math.max(0, +(this.balance - this.pendingAmount).toFixed(2));
  }

  constructor(model: WalletModel) {
    this.balance = model.balance ?? 0;
    // FRC-858: default to 0 like the two bucket fields below — a missing pendingAmount
    // would otherwise make every balance calculation NaN.
    this.pendingAmount = model.pendingAmount ?? 0;
    this.openOrdersHoldAmount = model.openOrdersHoldAmount ?? 0;
    this.withdrawalRequestsHoldAmount = model.withdrawalRequestsHoldAmount ?? 0;
    this.ecfInvestmentHoldAmount = model.ecfInvestmentHoldAmount ?? 0;
    this.status = model.status;
    this.ecfAccountNo = model.ecfAccountNo;
    this.userId = model.userId;
  }
}
